let redirectFn = null;

export const setRedirectFn = (fn) => {
  redirectFn = fn;
};

export const getRedirectFn = () => redirectFn;